import { ButtonBase } from "@mui/material";
import { useEffect, useState } from "react";

import "./switch-box.css";

const SwitchBox = (props) => {
  const { title, tabs, value, disabled } = props;
  const [tabIdx, setTabIdx] = useState(0);

  const handleSwitch = (idx, tabId) => {
    setTabIdx(idx);
    //redux store-> pending table > flooring data modify
    if (props.settingsHandle) {
      let titleName = title ? title.toLowerCase() : "";
      if (titleName === 'category') {
        titleName = 'type';
      } else if (titleName === 'type') {
        titleName = 'category';
      }
      props.settingsHandle(idx, titleName, tabId);
    }
  };

  useEffect(() => {
    setTabIdx(0);
  }, [tabs]);

  return (
    <div className="switch-box">
      {title && <label>{title}</label>}
      <div className="switch-body">
        {tabs !== undefined && tabs !== null && tabs?.length > 0 && tabs.map((tab, idx) => (
          <ButtonBase
            key={idx}
            disabled={disabled ? true : tab.disabled ? true : false}
          >
            <span
              // className={`switch ${value !== undefined
              //   ? value == tab.id && "active"
              //   : tabIdx == idx && "active"
              //   }`}
              className={`switch ${tabIdx === idx ? "active" : ""}`}
              onClick={() => handleSwitch(idx, tab.id)}
            >
              {tab.name}
            </span>
          </ButtonBase>
        ))}
      </div>
    </div>
  );
};

export default SwitchBox;
